import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { get } from 'lodash';

import { fetchTicketList } from '../../eventActions';
import { openLoginModal } from 'Parts/ui/uiActions';

import BuyTicketBtn from './BuyTicketBtn';

const mapStateToProps = state => ({
  entity: get(state, 'campaign.campaign'),
  locale: get(state, 'session.language'),
  tickets: get(state, 'Event.tickets'),
  settings: get(state, 'Event.event.settings'),
  userTypeId: get(state, 'session.userTypeId'),
  isBillingConfigured: get(state, 'organization.isBillingConfigured'),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchTicketList,
  openLoginModal
}, dispatch);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
)(BuyTicketBtn);
